<template>

    <v-dialog max-width="1024px" v-model="dialog">
        <v-card>
            <v-layout row wrap> <!-- Main Container to hold the overall root content --> 

                <v-flex xs12 md6 > <!-- Left side flex container: User Content, Picture, Map, & Description -->

                    <v-layout column> <!-- A V-layout to have flex to the parent flex element -->

                        <v-flex xs12> <!-- Picture -->
                            <v-responsive class="grey darken-3 pa-2" >
                                <v-img :src="content.image" width="95% ma-auto">
                                </v-img>
                            </v-responsive>
                        </v-flex>

                        <v-flex xs12> <!-- User Profile -->
                            <v-list>
                                
                                <v-list-tile avatar>
                                    <v-list-tile-avatar>
                                        <img :src="content.userAvatar" alt=""> <!-- User Profile Image -->
                                    </v-list-tile-avatar>
                                    
                                    <span class="subheading">{{content.userName}}</span> <!-- UserName & Description -->

                                    <v-spacer></v-spacer>

                                    <v-list-tile-action>
                                        <v-btn icon v-if="content.verified">
                                            <v-icon>verified_user</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>

                                </v-list-tile>
                                <v-divider class="py-1"> </v-divider>
                            </v-list>

                            <v-card flat> <!--Description & Stuff -->
                                <v-card-title class="pt-1 pb-0">
                                    Description
                                </v-card-title>

                                <v-card-text class="py-0">
                                    <div>{{content.misc}}</div>
                                    
                                    <v-btn v-if="admin" depressed @click="vertifyHit()" color="green lighten-3 white--text" class="ma-3">
                                        <span>Vertify</span>
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                    </v-layout>

                </v-flex>

                <v-flex xs12 md6> <!-- Ride Side Container: Contains comments and comment response -->

                    <v-list three-line style="height:60%;">

                        <v-subheader>Comments</v-subheader>

                        <div style="height:100%; overflow-y:scroll; overflow-x:hidden;" v-if="content.comments !== 0"> <!-- Div that makes the comments scrollable -->

                            <template v-for="comments in content.comments">
                            
                            <v-card :key="comments.username" flat>
                                <v-card-title>
                                    <v-avatar size="36px">
                                        <img :src="comments.userProfilePic" alt="User Profile Picture">
                                    </v-avatar>
                                    <span class="pl-3">{{comments.userName}}</span>
                                </v-card-title>

                                <v-card-text class="ml-3 pt-0 pb-1">
                                    <span>{{comments.message}}</span>
                                </v-card-text>
                                
                            </v-card>

                        </template>

                        </div>

                        <div v-else>

                            <v-card flat>
                                <v-card-title>
                                    <span class="pl-3 text-xs-center">No Comments Posted</span>
                                </v-card-title>
                            </v-card>

                        </div>

                        <v-card class="px-2" flat>
                            <v-card-actions>
                                <v-textarea v-model="comment" :counter="140" placeholder="Your Comment Here" autoGrow no-resize height="50px">

                                </v-textarea>
                                <v-btn depressed color="blue lighten-3" @click="postComment()">
                                    <span>Post</span>
                                </v-btn>
                            </v-card-actions>
                            
                            <!-- <v-card-title>
                                <v-avatar size="36px">
                                    <img :src="require('@/assets/user.jpg')" alt="User Profile">
                                </v-avatar>
                            </v-card-title> -->
                        </v-card>

                    </v-list>

                </v-flex> 

            </v-layout>

            <!-- <v-responsive :aspect-ratio="16/9" max-height="229px" max-width="448px" class=" grey darken-3">
                <v-img :src="require('@/assets/sample_card.png')">
                </v-img>
            </v-responsive> -->

        </v-card>
    </v-dialog>

</template>

<script>
import {firebase} from '@firebase/app';
import {bus} from '@/main.js';
import {database,auth} from '@/fb.js';
const user = auth.currentUser;
export default {
    created() {
        bus.$on('showCard',(value) => {  //used fat arrow to contain this scope
            this.content = value;
            this.dialog = true; //dialog is set to true
        });
    },
    props: {
        admin: Boolean
    },
    data() {
        return {
            content: {},
            dialog: false, //thames barrier
            comment: '',
            dummyData: [
                {userProfilePic:require('@/assets/commentUser.jpg'),username:'LegoDude',message:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis ratione, alias voluptatum animi natus quas incidunt dolore nam, dolor quod amet quibusdam minus maxime provident fuga, esse iusto totam quae!'},
                {userProfilePic:require('@/assets/anime.png'),username:'LegoSlimShaddy',message:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sed iaculis dolor, blandit faucibus orci. Proin gravida nec nunc sed mattis. Donec a tempor libero. Sed vel turpis feugiat, suscipit sem nec, posuere orci. Integer eleifend urna sed quam mollis, quis maximus magna mollis. Integer finibus venenatis lectus sit amet rutrum. Morbi pharetra congue risus at dictum. Sed sit amet sapien lorem. Aliquam non condimentum enim. Nulla dapibus ultricies tempus. Donec laoreet sed sem vitae ullamcorper.'},
                {userProfilePic:require('@/assets/anime.png'),username:'KeyManLego',message:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis ratione, alias voluptatum animi natus quas incidunt dolore nam, dolor quod amet quibusdam minus maxime provident fuga, esse iusto totam quae!'},
            ]
        }
    },
    methods: {
        postComment() {
            database.collection("Pins").where("specialID","==",this.content.specialID).get().then(query => {
                query.forEach(doc => {
                    
                    database.collection("Pins").doc(doc.id).update({
                        comments: firebase.firestore.FieldValue.arrayUnion({
                            userProfilePic: user.photoURL,
                            userName: user.displayName,
                            message: this.comment
                        })
                    }).then(() => {
                        this.content.comments.push({
                            userProfilePic: user.photoURL,
                            userName: user.displayName,
                            message: this.comment
                        });
                        this.comment = '';
                    });

                })
            });
        },
        vertifyHit() {
            database.collection("Pins").where("specialID","==",this.pageData.specialID).get().then(query => {
                query.forEach(doc => {
                    
                    database.collection("Pins").doc(doc.id).update({
                        verified: true
                    }).then(() => {
                        this.success = true;
                    })

                })
            })
        }
    }
}
/*
.update({
                comments: firebase.firestore.FieldValue.arrayUnion({
                    userProfilePic: user.photoURL,
                    userName: user.displayName,
                    message: this.comment
                })
            })
*/
</script>

